// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3qEGM","addWidgetButton":"Header_addWidgetButton__2bOPG","dashboardTabs":"Header_dashboardTabs__2wgwM","active":"Header_active__1_c8X"};